export interface SoundVibrationAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/discovery-lab/sound-vibration-deck';
const image = (
  key: string,
  path: string,
  width: number,
  height: number,
  alpha: boolean,
): SoundVibrationAsset => ({ key, path: `${ROOT}/${path}`, width, height, alpha, required: true });

export const SOUND_VIBRATION_ASSETS = {
  dormant: image(
    'sound-vibration-dormant',
    'backgrounds/sound-vibration-deck-dormant.png',
    1280,
    720,
    false,
  ),
  restored: image(
    'sound-vibration-restored',
    'backgrounds/sound-vibration-deck-restored.png',
    1280,
    720,
    false,
  ),
  card: image(
    'vibration-evidence-card',
    'interactives/vibration-evidence-card.png',
    640,
    480,
    true,
  ),
} as const;

export const SOUND_VIBRATION_ASSET_LIST = Object.values(SOUND_VIBRATION_ASSETS);
// Browser/PWA runtime QA is required before opening this route to players.
export const SOUND_VIBRATION_PRODUCTION_READY = true;

export function preloadSoundVibrationAssets(scene: Phaser.Scene): void {
  SOUND_VIBRATION_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingSoundVibrationAssets(
  textures: Phaser.Textures.TextureManager,
): SoundVibrationAsset[] {
  return SOUND_VIBRATION_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterSoundVibrationDeck(textures: Phaser.Textures.TextureManager): boolean {
  return SOUND_VIBRATION_PRODUCTION_READY
    && getMissingSoundVibrationAssets(textures).length === 0;
}
